import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" path="/404" />
      <section className="mx-auto flex max-w-2xl flex-col items-center px-5 py-32 text-center sm:px-8">
        <p className="font-heading text-7xl font-bold text-gradient">404</p>
        <h1 className="mt-4 font-heading text-3xl font-semibold tracking-tight text-foreground">
          Page not found
        </h1>
        <p className="mt-3 max-w-md text-muted-foreground">
          The page you're looking for doesn't exist or has moved. Let's get you back home.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-btn"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-all hover:opacity-90"
        >
          <Home className="h-4 w-4" /> Back to home
        </Link>
      </section>
    </>
  );
}
